import React, { useState } from 'react';
import api from '../services/api';
import { toast } from 'react-toastify';
import config from '../config/appConfig';
import '../styles/AssetManagement.css';

const RegisterAsset = ({ onAssetRegistered }) => {
  const [assetId, setAssetId] = useState('');
  const [loading, setLoading] = useState(false);

  // e.g. "MED-A1B2C3D4" or "PET-A1B2C3D4"
  const exampleId = `${config.assetPrefix}-A1B2C3D4`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await api.post('/api/assets/register', { 
        assetId: assetId.trim().toUpperCase() 
      });
      
      toast.success('Asset registered successfully!');
      setAssetId('');
      
      if (onAssetRegistered) {
        onAssetRegistered(res.data.asset);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to register asset');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-asset-section">
      <h2>Register New QR Code Asset</h2>
      <p>Enter the Asset ID found on your physical QR code device</p>

      <form onSubmit={handleSubmit} className="register-asset-form">
        <div className="form-group">
          <label>Asset ID</label>
          <input
            type="text"
            value={assetId}
            onChange={(e) => setAssetId(e.target.value)}
            placeholder={`e.g., ${exampleId}`}
            required
            pattern="[A-Za-z0-9-]+"
            style={{ textTransform: 'uppercase' }}
          />
          <small>Format: {config.assetPrefix}-XXXXXXXX (found on your QR code device)</small>
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Registering...' : 'Register Asset'}
        </button>
      </form>

      <div className="info-box">
        <h4>📱 How to find your Asset ID</h4>
        <ul>
          <li>Look for the text below or near the QR code on your device</li>
          <li>It starts with "{config.assetPrefix}-" followed by 8 characters</li>
          <li>Example: {exampleId}</li>
        </ul>
      </div>
    </div>
  );
};

export default RegisterAsset;
